import React, { FC, useMemo } from 'react';

import { SearchResponse } from '@ariksa/inventory-core/api';
import { Box } from '@chakra-ui/react';

import { AbsoluteSpinner } from 'components/DataDisplay/Spinner/AbsoluteSpinner';
import { PostureGraph } from 'components/Visualization/PixiGraph/components/PostureGraph';
import { PostureGraphContextProvider } from 'components/Visualization/PixiGraph/maps/PostureMap/hooks/usePostureGraphContext';
import { useIntoGraphNodes } from 'containers/Visibility/SecurityGraphNext/hooks/useIntoGraphNodes';

interface IAccessGraphWithContext {
  data: SearchResponse;
  isLoading: boolean;
  isLoaded: boolean;
}

export const PostureGraphWithContext: FC<IAccessGraphWithContext> = props => {
  const { data, isLoading, isLoaded } = props;
  const { intoGraphNodes } = useIntoGraphNodes();

  const graphData = useMemo(() => {
    const graphData = data.nodes?.map(n => ({
      ...n,
      id: n.identity,
    }));

    return intoGraphNodes(graphData ?? []);
  }, [data.nodes, intoGraphNodes]);

  return (
    <PostureGraphContextProvider
      value={{
        nodes: graphData,
        edges: data.relationships ?? [],
        isLoading: isLoading,
        isLoaded: isLoaded,
      }}
    >
      <Box w={'full'} h={'full'} pos={'relative'}>
        <PostureGraph />

        <AbsoluteSpinner isLoading={isLoading} />
      </Box>
    </PostureGraphContextProvider>
  );
};
